export default {
    ADD_RECENTLY_VIEWED: 'ITEMS/ADD_RECENTLY_VIEWED',
    SET_RECENTLY_VIEWED: 'ITEMS/SET_RECENTLY_VIEWED',
    INITIALIZE: 'ITEMS/INITIALIZE',
    WISHLIST: 'ITEMS/WISHLIST',
    WISHLIST_ADD_RANGE: 'ITEMS/WISHLIST_ADD_RANGE',
    WISHLIST_REMOVE_RANGE: 'ITEMS/WISHLIST_REMOVE_RANGE',
    SETTINGS: 'ITEMS/SETTINGS'
};
